import { putCompleteProfileData } from "../../api/authenticationController";

const FallbackMessage = "Something went wrong. Please try again or contact support.";

export const updateProfileData = async ({
	firstName,
	lastName,
	mobile,
	wholesaleTrader,
	personalIdNumber,
	companyRegNo,
	personalCapacity,
	setResultMessage,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	try {
		setStatusInProgress();
		let response = await putCompleteProfileData({
			firstName,
			lastName,
			mobile,
			wholesaleTrader,
			personalIdNumber: personalCapacity ? personalIdNumber : null,
			companyRegNo: personalCapacity ? null : companyRegNo
		});

		if (!!response?.success) {
			setResultMessage(response.message);
			setStatusSuccess();
		}
		else {
			setResultMessage(response?.message ?? FallbackMessage);
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setResultMessage(FallbackMessage);
		setStatusError();
	}
};